import { render, staticRenderFns } from "./ReclamationsDealers.vue?vue&type=template&id=185ad645&"
import script from "./ReclamationsDealers.vue?vue&type=script&lang=js&"
export * from "./ReclamationsDealers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports